import { render } from "./branch.vue?vue&type=template&id=736ab1a0&scoped=true&ts=true"
import script from "./branch.vue?vue&type=script&lang=ts"
export * from "./branch.vue?vue&type=script&lang=ts"

import "./branch.vue?vue&type=style&index=0&id=736ab1a0&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736ab1a0"]])

export default __exports__